// Characters that are not allowed in file names on Windows or macOS
const INVALID_FILE_NAME_CHARACTERS = /[\\/:*?"<>|]+/g;

const toFileName = (name: string): string =>
  name.replace(INVALID_FILE_NAME_CHARACTERS, ' ').replace(/\s+/g, ' ').trim();

// Downloads a file with a file name chosen by the client instead of the server
const downloadNamedFile = (
  data: any,
  mimeType: string,
  fileName: string
): void => {
  const blob = new Blob([data], { type: mimeType });
  const objectUrl = URL.createObjectURL(blob);

  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  anchor.download = toFileName(fileName);
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();

  // Several files are downloaded in a row, so the URL is released after a delay
  setTimeout(() => URL.revokeObjectURL(objectUrl), 10000);
};

export default downloadNamedFile;
